import React from "react";
/* eslint-disable @typescript-eslint/no-empty-interface */
interface Props {}

const ComingSoon: React.FC<Props> = () => {
  return (
    <div className="w-full">
      <img className="mx-auto" src="/assets/other/coming-soon.svg" />
      <div className="text-center text-2xl font-bold mt-2">
        Từ từ sắp có rồi nha...
      </div>
    </div>
  );
};

export default ComingSoon;
